import React, { useState } from "react";
import { Link, useNavigate } from 'react-router-dom';
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";
import 'react-toastify/dist/ReactToastify.css';
import "../styles/Auth.css";
import logo from '../assets/images/logo.png';

const Login = () => {
  const navigate = useNavigate();
  const [userid, setUserid] = useState("");
  const [password, setPassword] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const [errors, setErrors] = useState({});
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // API Base URL - Using the working API endpoint
  const API_BASE = "https://api.mbsmartweb.com";

  const validate = () => {
    const newErrors = {};
    if (!userid) newErrors.userid = "User ID is required";
    if (!password) newErrors.password = "Password is required";
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validate();
    
    if (Object.keys(newErrors).length === 0) {
      setIsLoading(true);
      
      try {
        const response = await axios.post(`${API_BASE}/api/login`, {
          userid: userid,
          password: password,
        });

        const { status, Userid, message } = response.data;

        if (status === 1) {
          // Save user info locally
          localStorage.setItem("UserId", Userid);
          
          if (rememberMe) {
            localStorage.setItem("rememberMe", "true");
            localStorage.setItem("savedUserId", userid);
          } else {
            localStorage.removeItem("rememberMe");
            localStorage.removeItem("savedUserId");
          }
          
          // Show success toast
          toast.success("Login successful!");
          
          // Redirect to dashboard after short delay
          setTimeout(() => navigate("/dashboard"), 1000);
        } else {
          // Show error message
          toast.error(message || "Invalid credentials");
        }
      } catch (err) {
        console.error("Login API Error:", err);
        toast.error("Server error. Please try again later.");
      } finally {
        setIsLoading(false);
      }
    } else {
      setErrors(newErrors);
    }
  };

  // Load saved user ID on component mount
  React.useEffect(() => {
    const savedUserId = localStorage.getItem("savedUserId");
    const savedRememberMe = localStorage.getItem("rememberMe");
    if (savedRememberMe === "true" && savedUserId) {
      setUserid(savedUserId);
      setRememberMe(true);
    }
  }, []);

  return (
    <div className="auth-container">
      <ToastContainer 
        position="top-right" 
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
      />
      
      <div className="auth-card">
        <div className="auth-header">
          <img src={logo} alt="LogicraNetwork" className="auth-logo" />
          <h2 className="auth-title">Login to Continue</h2>
          <p className="auth-subtitle">Sign in to access your dashboard</p>
        </div>

        <form onSubmit={handleSubmit} className="auth-form">
          <div className="form-group">
            <label htmlFor="userid">User ID / Email</label>
            <div className="input-wrapper">
              <i className="fa fa-user"></i>
              <input
                type="text"
                id="userid"
                name="userid"
                placeholder="User ID / Email"
                value={userid}
                onChange={(e) => setUserid(e.target.value)}
                className={errors.userid ? "error" : ""}
                disabled={isLoading}
                autoComplete="username"
              />
            </div>
            {errors.userid && <span className="error-message">{errors.userid}</span>}
          </div>

          <div className="form-group">
            <label htmlFor="password">Password</label>
            <div className="input-wrapper">
              <i className="fa fa-lock"></i>
              <input
                type={showPassword ? "text" : "password"}
                id="password"
                name="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className={errors.password ? "error" : ""}
                disabled={isLoading}
                autoComplete="current-password"
              />
              <i 
                className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"} password-toggle`}
                onClick={() => setShowPassword(!showPassword)}
                style={{ cursor: "pointer" }}
              ></i>
            </div>
            {errors.password && <span className="error-message">{errors.password}</span>}
          </div>

          <div className="form-options">
            <label className="checkbox-label">
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
                disabled={isLoading}
              />
              <span>Remember me</span>
            </label>
            <Link to="/forgot-password" className="forgot-link">Forgot Password?</Link>
          </div>

          <button type="submit" className={`auth-btn ${isLoading ? "loading" : ""}`} disabled={isLoading}>
            {isLoading ? (
              <>
                <i className="fa fa-spinner fa-spin"></i> SIGNING IN...
              </>
            ) : (
              "SIGN IN"
            )}
          </button>

          <div className="auth-footer">
            Don't have an account? <Link to="/register">Register Now!</Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;